import { FunctionComponent } from 'react';
import styles from './DescriptionText.module.scss';

interface DescriptionTextProps {
    text: string;
    className?: string;
}

export const DescriptionText: FunctionComponent<DescriptionTextProps> = ({ text, className }) => {
    return <div className={`${styles.description} ${className || ''}`}>{text}</div>;
};

export default DescriptionText;
